<template>
  <div id="user">
    <section class="bd-index-fullscreen bg-blue-navy hero is-fullheight">
      <div class="hero-head">
        <div class="tabs is-centered">
          <ul>
            <li class="has-background-success">
              <router-link to="/dashboard">Console</router-link>
            </li>
            <li class="has-background-success">
              <router-link to="/settings">Edit</router-link>
            </li>
            <li class="has-background-success">
              <a @click="logout">Logout</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns box box-shadow-dark bg-navy-dark is-paddingless">
            <div class="column is-paddingless bg-blue-grey">
              <div class="card-content">
                <div class="content">
                  <span class="is-size-4">{{ name }} </span>
                  @johnsmith
                  <br />
                  UX Designers, {{ title }} | London, United Kingdom
                  <hr />
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. sem. Etiam finibus odio quis...
                  </p>
                  <p>
                    profileUserID = {{ profileUserID }}
                  </p>
                  <p>
                    currentUserID = {{ currentUser.uid }} - {{ currentUser.email }} 
                  </p>
                  <p class="is-hidden-desktop">
                    <a @click="openFeedsModal()">Latest</a>
                  </p>
                  <div class="box bg-navy-dark is-shadowless">
                    <div class="columns">
                      <div class="column">
                        <b-field>
                          <p class="control">
                            <b-dropdown>
                              <button class="button is-warning" slot="trigger">
                                <span>Filters</span>
                                <b-icon icon="menu-down"></b-icon>
                              </button>
                              <b-dropdown-item value="open_issues">Open Issues and Pull Requests</b-dropdown-item>
                              <b-dropdown-item value="your_issues">Your Issues</b-dropdown-item>
                              <b-dropdown-item value="pull_requests">Your Pull Requests</b-dropdown-item>
                              <b-dropdown-item value="everything">Everything</b-dropdown-item>
                            </b-dropdown>
                          </p>
                          <b-input icon="magnify" type="search" placeholder="Search..."></b-input>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <b-field>
                          <b-input placeholder="Credit card"
                              icon-pack="far"
                              icon="credit-card">
                          </b-input>
                        </b-field>
                      </div>
                    </div>
                    <router-link class="button is-primary-grad is-rounded" to="/post">Submit Donation</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-paddingless is-hidden-touch" style="max-height: 30em; overflow: auto;">
              <div v-if="posts.length">
                <div v-for="post in posts" v-bind:key="post.value" class="post">
                  {{ post.userName }}
                  <span class="text-light size-small">
                    <i>{{ post.createdOn | formatDate }}</i>
                  </span>
                  <p>{{ post.content | trimLength }}</p>
                </div>
              </div>
              <div v-else>
                <p class="no-results">There are currently no posts</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hero-foot">
        <div class="container">
          <div class="tabs is-centered">
            <ul>
              <li>
                <a>
                  <img src="@/assets/logo.png" alt="Image" width="60px">
                </a>
              </li>
              <li>Secure .</li>
              <li>&nbsp;Simple .</li>
              <li>&nbsp;Better</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <b-modal :active.sync="isCardModalActive" :width="640" scroll="keep">
      <div class="card">
        <div class="card-image">
          <figure class="image is-4by3">
            <img src="@/assets/logo.png" alt="Image">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="/static/img/placeholder-1280x960.png" alt="Image">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">John Smith</p>
              <p class="subtitle is-6">@johnsmith</p>
            </div>
          </div>
          <div class="content">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Phasellus nec iaculis mauris.
            <a>@bulmaio</a>.
            <a>#css</a>
            <a>#responsive</a>
            <br>
            <small>11:09 PM - 1 Jan 2016</small>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="showPostModal" :width="640" scroll="keep">
      <div class="box bg-grey-dark">
        <h5>{{ fullPost.userName }}</h5>
        <span>{{ fullPost.createdOn | formatDate }}</span>
        <p>{{ fullPost.title }} | {{ fullPost.content }}</p>
        <ul>
          <li>
            <a>comments {{ fullPost.comments }}</a>
          </li>
          <li>
            <a>likes {{ fullPost.likes }}</a>
          </li>
        </ul>
      </div>
      <div v-show="postComments.length" class="comments">
        <div v-for="comment in postComments" v-bind:key="comment" class="comment">
          <p>{{ comment.userName }}</p>
          <span>{{ comment.createdOn | formatDate }}</span>
          <p>{{ comment.content }}</p>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="showFeedsModal" :width="640" scroll="keep">
      <div class="box has-background-black-ter">
        <div v-if="posts.length">
          <div v-for="post in posts" v-bind:key="post.value" class="post">
            <!--<div v-if="post.userId == currentUser.uid">
              
              <b-dropdown hoverable aria-role="list" class="is-pulled-right">
                <a slot="trigger">
                  <font-awesome-icon icon="ellipsis-h"></font-awesome-icon>
                  <span>Edit</span>
                  <b-icon icon="menu-down"></b-icon>
                </a>
                <b-dropdown-item aria-role="listitem">Edit</b-dropdown-item>
                <b-dropdown-item aria-role="listitem"><a @click="deletePost(post)">Delete</a></b-dropdown-item>
              </b-dropdown>
            </div>-->
            {{ post.userName }}
            <span class="text-light size-small">
              <i>{{ post.createdOn | formatDate }}</i>
            </span>
            <p>{{ post.content | trimLength }}</p>
            <!--
            <ul>
              <li>
                <a @click="openCommentModal(post)">comments {{ post.comments }}</a>
              </li>
              <li>
                <a @click="likePost(post.id, post.likes)">likes {{ post.likes }}</a>
              </li>
              <li>
                <a @click="viewPost(post)">view full post</a>
              </li>
            </ul>-->
          </div>
        </div>
        <div v-else>
          <p class="no-results">There are currently no posts</p>
        </div>
      </div>
    </b-modal>

    <!-- comment modal 
    <transition name="fade">
      <div v-if="showCommentModal" class="c-modal">
        <div class="c-container">
          <a @click="closeCommentModal">X</a>
          <p>add a comment</p>
          <form @submit.prevent>
            <textarea v-model.trim="comment.content"></textarea>
            <button @click="addComment" :disabled="comment.content == ''" class="button">add comment</button>
          </form>
        </div>
      </div>
    </transition>-->

    <!-- post modal 
    <transition name="fade">
      <div v-if="showPostModal" class="p-modal">
        <div class="p-container">
          <a @click="closePostModal" class="close">X</a>
          <div class="post">
            <h5>{{ fullPost.userName }}</h5>
            <span>{{ fullPost.createdOn | formatDate }}</span>
            <p>{{ fullPost.title }} | {{ fullPost.content }}</p>
            <ul>
              <li>
                <a>comments {{ fullPost.comments }}</a>
              </li>
              <li>
                <a>likes {{ fullPost.likes }}</a>
              </li>
            </ul>
          </div>
          <div v-show="postComments.length" class="comments">
            <div v-for="comment in postComments" v-bind:key="comment" class="comment">
              <p>{{ comment.userName }}</p>
              <span>{{ comment.createdOn | formatDate }}</span>
              <p>{{ comment.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      post: {
        title: "",
        content: ""
      },
      comment: {
        postId: "",
        userId: "",
        content: "",
        postComments: 0
      },
      fullPost: {},
      postComments: [],
      showPostModal: false,
      showFeedsModal: false,
      userProfileID:this.$route.params.id,
      name: null,
      title: null,
    };
  },

  computed: {
    ...mapState(["userProfile", "currentUser", "posts", "hiddenPosts"])
  },
  methods: {
    showUser(){
      let docId = this.$route.params.id;

      fb.usersCollection
        .doc(docId)
        .get()
        .then(docs => {
          console.log(docs.id, ' => ', docs.data())
          console.log("docs title: " + docs.data().title);
          this.name = docs.data().name
          this.title = docs.data().title
          this.profileUserID = docId;
          //this.fullUser.title = docs.title;// = users;
        })
        .catch(err => {
          console.log(err);
        });
    },
    showNewPosts() {
      let updatedPostsArray = this.hiddenPosts.concat(this.posts);
      // clear hiddenPosts array and update posts array
      this.$store.commit("setHiddenPosts", null);
      this.$store.commit("setPosts", updatedPostsArray);
    },
    /*
    openCommentModal(post) {
      this.comment.postId = post.id;
      this.comment.userId = post.userId;
      this.comment.postComments = post.comments;
      this.showCommentModal = true;
    },
    closeCommentModal() {
      this.comment.postId = "";
      this.comment.userId = "";
      this.comment.content = "";
      this.showCommentModal = false;
    },
    addComment() {
      let postId = this.comment.postId;
      let postComments = this.comment.postComments;

      fb.commentsCollection
        .add({
          createdOn: new Date(),
          content: this.comment.content,
          postId: postId,
          userId: this.currentUser.uid,
          userName: this.userProfile.name
        })
        .then(doc => {
          fb.postsCollection
            .doc(postId)
            .update({
              comments: postComments + 1
            })
            .then(() => {
              this.closeCommentModal();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },*/
    likePost(postId, postLikes) {
      let docId = `${this.currentUser.uid}_${postId}`;

      fb.likesCollection
        .doc(docId)
        .get()
        .then(doc => {
          if (doc.exists) {
            return;
          }

          fb.likesCollection
            .doc(docId)
            .set({
              postId: postId,
              userId: this.currentUser.uid
            })
            .then(() => {
              // update post likes
              fb.postsCollection.doc(postId).update({
                likes: postLikes + 1
              });
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    viewPost(post) {
      fb.commentsCollection
        .where("postId", "==", post.id)
        .get()
        .then(docs => {
          let commentsArray = [];

          docs.forEach(doc => {
            let comment = doc.data();
            comment.id = doc.id;
            commentsArray.push(comment);
          });

          this.postComments = commentsArray;
          this.fullPost = post;
          this.showPostModal = true;
        })
        .catch(err => {
          console.log(err);
        });
    },

    /*

    showEditPost(){
      isPostEdit = true
    },
    hideEditPost(){
      isPostEdit = false
    },*/

    openFeedsModal(){
      this.showFeedsModal = true;
    },
    /*

    createPost() {
      fb.postsCollection
        .add({
          createdOn: new Date(),
          content: this.post.content,
          userId: this.currentUser.uid,
          userName: this.userProfile.name,
          comments: 0,
          likes: 0
        })
        .then(ref => {
          this.post.content = "";
          this.$toast.open({
            message: "Your Post was successfully added!",
            queue: false,
            type: "is-success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    deletePost(post) {
      let docId = `${post.id}`;
      fb.postsCollection
        .doc(post.id)
        .delete()
        .then(() => {
          this.showDeleteModal = false;
          this.$toast.open({
            message: "Your Post was successfully deleted!",
            queue: false,
            type: "is-success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    updatePost(post) {
      let docId = `${post.id}`;

      fb.postsCollection
        .doc(post.id)
        .update({
          title: post.title
        })
        .catch(err => {
          console.log(err);
        });
    }*/
  },
  beforeMount(){
    this.showUser()
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  }
};
</script>